import React from "react";
import styles from "../style.css";

const Placeholder = ({ dropdownCls }) => (
  <div class={styles.container + " " + styles.placeholder + dropdownCls}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default Placeholder;
